import INTL from './types'

export const switchLanguage = (language) => ({
  type: INTL.SWITCH_LANGUAGE,
  language,
})

export const switchShowButton = (show) => ({
  type: INTL.SWITCH_BUTTON,
  show,
})


// WEBPACK FOOTER //
// ./src/store/intl/actions.js